export const createInitialsPreview = (initials: string): string => {
	const initialsText = initials?.toLocaleUpperCase() || ""
	const canvas = createCanvas(initialsText, 40)
	return canvas.toDataURL("image/jpeg", 0.9)
}

export const createCanvas = (initialsText: string, size = 80) => {
	const royalColor = getComputedStyle(document.documentElement)
		.getPropertyValue("--mantine-color-royal-8")
		.trim()

	const canvas = document.createElement("canvas")
	const ctx = canvas.getContext("2d")
	if (!ctx) return canvas
	canvas.width = size
	canvas.height = size

	// Draw circle background
	ctx.fillStyle = royalColor
	ctx.beginPath()
	ctx.arc(size / 2, size / 2, size / 2, 0, 2 * Math.PI)
	ctx.fill()

	// Draw initials text
	ctx.fillStyle = "white"
	ctx.font = `${size * 0.4}px Arial, sans-serif`
	ctx.textAlign = "center"
	ctx.textBaseline = "middle"
	ctx.fillText(initialsText, size / 2, size / 2)

	return canvas
}

export const createInitialsAvatar = async (
	initials: string
): Promise<{
	url: string
	file: File
}> => {
	const initialsText = initials?.toLocaleUpperCase() || ""
	const canvas = createCanvas(initialsText, 210)
	return new Promise((resolve) => {
		canvas.toBlob(
			(blob) => {
				const url = canvas.toDataURL("image/jpeg", 0.9)
				const file = new File(blob ? [blob] : [], "initials-avatar.jpg", {
					type: "image/jpeg"
				})
				resolve({ url, file })
			},
			"image/jpeg",
			0.9
		)
	})
}
